<div class="modal-wrapper">
  <div class="modal-header">
    <h4 class="modal-title" i18n="@@document.list.contact.info.edit.title">
      Edit contact info
    </h4>
    <i class="fas fa-times" (click)="onClose()"></i>
  </div>
  <div
    class="modal-body"
    [formGroup]="contactForm"
    *ngIf="!addNewContactScreenActive"
  >
    <div class="section card list">
      <span class="header" i18n="@@general.contacts">Contacts</span>
      <div class="contactList scrollbar">
        <div
          class="contactListItem clickable"
          [class.selected]="contact.id === selectedContactId"
          (click)="onSelectContact(contact.id)"
          *ngFor="let contact of documentItem.contacts"
        >
          {{ contact.name }} -
          <span class="roleName">{{ formatPersonType(contact.type) }}</span>
        </div>
      </div>
      <img
        class="clickable add-button"
        src="assets/Keen&Wise_add_photo_transparant.png"
        (click)="onAddContactBtn()"
        *ngIf="!addNewContactScreenActive"
      />
    </div>
    <div *ngIf="selectedContactId" class="section card details">
      <span class="header" i18n="@@general.contact.info">Contact info</span>
      <div>
        <div class="input-wrapper">
          <label class="inputLabel" i18n="@@general.name">Name</label>
          <input
            formControlName="name"
            [class.invalid-select]="
              this.contactForm.get('name').errors &&
              (this.contactForm.get('name').touched ||
                this.contactForm.get('name').dirty)
            "
          />
        </div>

        <div class="input-wrapper">
          <label class="inputLabel" i18n="@@general.phone.number"
            >Phone number</label
          >
          <input
            formControlName="phone"
            [class.invalid-select]="
              this.contactForm.get('phone').errors &&
              (this.contactForm.get('phone').touched ||
                this.contactForm.get('phone').dirty)
            "
          />
        </div>
        <div class="input-wrapper">
          <label class="inputLabel" i18n="@@general.email">Email</label>
          <input
            formControlName="email"
            [class.invalid-select]="
              this.contactForm.get('email').errors &&
              (this.contactForm.get('email').touched ||
                this.contactForm.get('email').dirty)
            "
          />
        </div>
        <div class="input-wrapper">
          <label class="inputLabel" i18n="@@general.language">Language</label>
          <select
            class="browser-default custom-select md-select"
            formControlName="language"
            [class.invalid-select]="
              this.contactForm.get('language').errors &&
              (this.contactForm.get('language').touched ||
                this.contactForm.get('language').dirty)
            "
          >
            <option
              *ngFor="let option of personLanguageOptions"
              [value]="option.value"
            >
              {{ option.displayName }}
            </option>
          </select>
        </div>
        <div class="input-wrapper">
          <label class="inputLabel" i18n="@@general.user.role">User role</label>
          <select
            class="browser-default custom-select md-select"
            formControlName="type"
            [class.invalid-select]="
              this.contactForm.get('type').errors &&
              (this.contactForm.get('type').touched ||
                this.contactForm.get('type').dirty)
            "
          >
            <option
              *ngFor="let option of personTypeOptions"
              [value]="option.value"
            >
              {{ option.displayName }}
            </option>
          </select>
        </div>
        <div class="input-wrapper">
          <label class="inputLabel" i18n="@@general.street">Street</label>
          <input
            formControlName="street"
            [class.invalid-select]="
              this.contactForm.get('street').errors &&
              (this.contactForm.get('street').touched ||
                this.contactForm.get('street').dirty)
            "
          />
        </div>
        <div class="input-wrapper">
          <label class="inputLabel" i18n="@@general.number">Number</label>
          <input
            formControlName="number"
            [class.invalid-select]="
              this.contactForm.get('number').errors &&
              (this.contactForm.get('number').touched ||
                this.contactForm.get('number').dirty)
            "
          />
        </div>
        <div class="input-wrapper">
          <label class="inputLabel" i18n="@@general.suffix">Suffix</label>
          <input formControlName="suffix" />
        </div>
        <div class="input-wrapper">
          <label class="inputLabel" i18n="@@general.postalcode"
            >Postal Code</label
          >
          <input
            formControlName="postalCode"
            [class.invalid-select]="
              this.contactForm.get('postalCode').errors &&
              (this.contactForm.get('postalCode').touched ||
                this.contactForm.get('postalCode').dirty)
            "
          />
        </div>
        <div class="input-wrapper">
          <label class="inputLabel" i18n="@@general.city">City</label>
          <input
            formControlName="city"
            [class.invalid-select]="
              this.contactForm.get('city').errors &&
              (this.contactForm.get('city').touched ||
                this.contactForm.get('city').dirty)
            "
          />
        </div>
      </div>
    </div>
  </div>
  <ng-container *ngIf="addNewContactScreenActive">
    <div class="search-contact-panel">
      <div class="title" i18n="@@document.list.contact.info.edit.addcontact">
        Add contact
      </div>
      <app-document-contact-search
        (selectResult)="onSelectSearchResult($event)"
        (newContact)="onNewContact()"
      ></app-document-contact-search>
    </div>
  </ng-container>
  <div class="modal-footer" *ngIf="selectedContactId">
    <img
      class="clickable remove-button"
      (click)="onRemoveContact()"
      src="assets/Keen&Wise_delete_round_transparant.png"
    />
    <img
      class="clickable save-button"
      (click)="onSave()"
      src="assets/Keen&Wise_save.png"
    />
  </div>
</div>
